import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WashIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wash"}/>
}
